import * as types from './types';
import createReducer from '../reducers';

const initialState = {
  isOpen: false
};
const toggle = (state, { payload }) => ({
  ...state,
  isOpen: payload,
});

export default createReducer(initialState, {
  [types.TOGGLE]: toggle,
});


// WEBPACK FOOTER //
// ./src/store/modal/reducer.js